// extracted by mini-css-extract-plugin
module.exports = {"tags":"scss_tags__ygfvl"};